
class EventListener {
    constructor() {
        this._listeners = [];
    }

    addEventListener(listener) {
        if (typeof listener !== 'function') throw new TypeError('EventListener is not a function');

        this._listeners.push(listener);
    }

    removeEventListener(listener) {
        if (typeof listener !== 'function') throw new TypeError('EventListener is not a function');

        const index = this._listeners.indexOf(listener);

        if (index !== -1) this._listeners.splice(index, 1);
    }

    dispatch(event) {
        this._listeners.forEach((listener) => {
            if (typeof listener == 'function') listener(event);
        });
    }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = EventListener;
}